export default __webpack_public_path__ + "static/media/icon_aligment.49833bc6.svg";